/**
 * Calls a function when a change occurs in node
 */
export function callWhenNodeChanges(node: Node, callback: (mutations: MutationRecord[]) => void) {
  const observer = new MutationObserver((mutations) => {
    callback(mutations);
    observer.disconnect();
  });

  observer.observe(node, {
    childList: true,
    subtree: true,
  });
}

/**
 * Returns added nodes
 */
export function getAddedNodes(parentNode: Node) {
  return new Promise<Node[]>((resolve) => {
    callWhenNodeChanges(parentNode, (mutations) => {
      const addedNodes = mutations.map((mutation) => [...mutation.addedNodes]).flat();
      resolve(addedNodes);
    });
  });
}
